// extracted by mini-css-extract-plugin
export var animationContainer = "_hb-0";
export var asteriskIcon = "_hb-8";
export var conversationLeftSection = "_hb-4";
export var conversationListItem = "_hb-3";
export var conversationMiddleSection = "_hb-5";
export var conversationRightSection = "_hb-6";
export var detailsContent = "_hb-1";
export var listContainer = "_hb-7";
export var modalContent = "_hb-2";